import { AuthGuard } from '../../../shared/services';
import { CagnottesListComponent } from './cagnottes-list.component';
// import { CagnottesListResolver } from './cagnottes-list.resolver';
import {Route} from '@angular/router';
import { CagnottesListEventTypeResolver } from './cagnottes-list_eventType.resolver';
import { AssociationsForFilterResolver } from 'app/private/associations/associations-for-filter/associations-for-filter.resolver';

export const CagnottesListRoutes: Route[] = [
  {
    path: "list/:type",
    component: CagnottesListComponent,
    canActivate: [AuthGuard],
    resolve: {
      //   jackpots: CagnottesListResolver,
      eventTypes: CagnottesListEventTypeResolver,
      assocsForFilter: AssociationsForFilterResolver,
    },
  },
];
